import { updateObjectInChildArrayAndRefreshCount } from "../utils/dbUtils";
import { auth } from "../firebase";
import { isBooleanTrue, isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import moment from 'moment-timezone';
import { toSubmittedAtDate } from '../utils/dateFormatter';
import { v4 as uuid } from 'uuid';
import Subscription from "./Subscription";

class SubscriptionForm {
    id = uuid();
    userId = null;

    surveyId = null;
    answers = [];

    submittedAt = null; // only set the value if the form is completed moment().utc().toDate()

    createdBy = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    createdAt = moment().utc().toDate();
    modifiedBy = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    modifiedAt = moment().utc().toDate();

    constructor(userForm) {
        if (isObjectNotEmpty(userForm)) {
            if (isStringNotEmpty(userForm.id)) { this.id = userForm.id; }
            if (isStringNotEmpty(userForm.userId)) { this.userId = userForm.userId; }

            if (isStringNotEmpty(userForm.surveyId)) { this.surveyId = userForm.surveyId; }
            if (isListNotEmpty(userForm.answers)) { this.answers = userForm.answers; }

            // the checkout callable rasterises a client Timestamp into a { seconds, nanoseconds } map,
            // which nothing can order - coerce it back on receipt
            if (isNotNullOrUndefined(userForm.submittedAt)) { this.submittedAt = toSubmittedAtDate(userForm.submittedAt); }

            if (isStringNotEmpty(userForm.createdBy)) { this.createdBy = userForm.createdBy; }
            if (isNotNullOrUndefined(userForm.createdAt)) { this.createdAt = userForm.createdAt; }
            if (isStringNotEmpty(userForm.modifiedBy)) { this.modifiedBy = userForm.modifiedBy; }
            if (isNotNullOrUndefined(userForm.modifiedAt)) { this.modifiedAt = userForm.modifiedAt; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            userId: this.userId,

            surveyId: this.surveyId,
            answers: this.answers,

            submittedAt: this.submittedAt,

            createdAt: this.createdAt,
            createdBy: this.createdBy,
            modifiedAt: this.modifiedAt,
            modifiedBy: this.modifiedBy
        };
    }

    static create = async (subscriptionId, formId, newForm) => {
        const newObj = new SubscriptionForm({
            id: formId,
            ...newForm,
            createdAt: moment().utc().toDate(),
            createdBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM',
            modifiedAt: moment().utc().toDate(),
            modifiedBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM'
        });
        const success = await updateObjectInChildArrayAndRefreshCount(Subscription.collectionName, subscriptionId, 'forms', 'id', newObj.toDto(), 'formsCount');
        if (isBooleanTrue(success)) {
            return newObj.toDto();
        }

        return null;
    }

    static update = async (subscriptionId, formId, updatedForm) => {
        const updatedObj = new SubscriptionForm({
            id: formId,
            ...updatedForm,
            modifiedAt: moment().utc().toDate(),
            modifiedBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM'
        });
        if (formId === updatedForm.id) {
            const success = await updateObjectInChildArrayAndRefreshCount(Subscription.collectionName, subscriptionId, 'forms', 'id', updatedObj.toDto(), 'formsCount');
            if (isBooleanTrue(success)) {
                return updatedObj.toDto();
            }
        } else {
            throw new Error('id and id field of the updated form must match.')
        }

        return null;
    }
};

export default SubscriptionForm;